<div *ngIf="!fullZoomPreview" class="zoom-component position-relative">
  <div 
    #container 
    *ngIf="imgSrc && hideVideo" 
    class="img-zoom-container" 
    [ngClass]="{ 'shadow-none rounded-lg border-gray': environmentVariables?.NEW_PRODUCTS_DETAILS_UI }"
    (mouseleave)="onMouseLeave()"
  >
    <div #zoomViewer fxShow="true" fxShow.gt-md class="d-md-block d-none">
      <mat-card *ngIf="zoomImage && lang === 'ar'" [ngStyle]="{ 'background-image': 'url(' + zoomImage + ')' }"
        class="zoom-viewer-ar mat-elevation-z18">
      </mat-card>

      <mat-card *ngIf="zoomImage && lang === 'en'" [ngStyle]="{ 'background-image': 'url(' + zoomImage + ')' }"
        class="zoom-viewer mat-elevation-z18">
      </mat-card>
    </div>

    <img #mainZoomImg class="w-100 h-100 obj-fit-contain rounded-lg" (click)="toggleFullZoomPreview()"
      (mousemove)="miniZoomImage($event)" [src]="zoomImage"    [alt]="productName" default="./assets/images/placeholder70.png"
      onError="this.src='./assets/images/placeholder70.png';" />

    <div (mousemove)="miniZoomImage($event)" class="img-zoom-lens d-md-block d-none" #zoomLens></div>

    <div class="fullwidth-icon" fxHide="false" fxHide.gt-md>
      <div class="mt-2 mr-2" fxLayout="column">
        <!-- full screen -->
        <div class="mb-2">
          <button 
            class="p-1 rounded-circle border-gray bg-white text-silver"
            fxLayout="row"
            fxLayoutAlign="center"
            (click)='toggleFullZoomPreview()'>
            <mat-icon>fullscreen</mat-icon>
          </button>        
        </div>

        <!-- favorite -->
        <div class="mb-2" *ngIf="environmentVariables?.NEW_PRODUCTS_DETAILS_UI">
          <button class="p-1 rounded-circle bg-white border-gray" 
            (click)="addToFavouriteList(product_variant)" 
            [disabled]="toggleFavLoading"  
            fxLayout="row"
            fxLayoutAlign="center"
            [ngClass]="
              product_variant?.is_favourite ? 'wishlist-active' : ''
            "
            [style.cursor]="toggleFavLoading ? 'not-allowed' : 'pointer'">
            <mat-icon 
              class="material-icons favorite"
              [class.wishlist-active]="product_variant?.is_favourite">
              favorite
            </mat-icon>
          </button>
        </div>
        
        <!-- compare -->
        <div class="mb-2" *ngIf="environmentVariables?.NEW_PRODUCTS_DETAILS_UI">
          <button 
            *ngIf="!environmentVariables?.DISABLE_COMPARE" 
            class="p-1 rounded-circle bg-white border-gray"
            (click)="addToCompareList(product_variant)" 
            [disabled]="toggleCompareLoading" 
            fxLayout="row"
            fxLayoutAlign="center"
            [ngClass]="
              product_variant?.is_compare ? 'wishlist-active' : ''
            "
            [style.cursor]="toggleCompareLoading ? 'not-allowed' : 'pointer'">
            <mat-icon 
              class="material-icons favorite"
              [class.wishlist-active]="product_variant?.is_compare">
              compare
            </mat-icon>
          </button>
        </div>

        <!-- share -->
        <button 
          *ngIf="environmentVariables?.NEW_PRODUCTS_DETAILS_UI"
          class="p-1 rounded-circle border-gray bg-white text-silver"
          fxLayout="row"
          fxLayoutAlign="center"
          (click)="openDialogShare()">
          <mat-icon>share</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div #container *ngIf="video && !hideVideo" class="img-zoom-container">
    <iframe [src]="youtubeTrustedUrl" height="660px" width="100%"></iframe>
  </div>

  <div class="d-flex flex-row py-1 px-0 image-gallery" [ngClass]="{
      'scrollable-width': gallaryScrollarea,
      'row-reverse': lang == 'ar'
    }">
    <div class="left-icon material-icons prev-arrow pointer" (click)="getPrevThumbnail()" *ngIf="gallaryScrollarea">
      keyboard_arrow_left
    </div>

    <div class="center-space px-1" id="image-gallery" #imageGallery>
      <div (mouseenter)="getImagePath('', 1000, 'video', false)" 
        *ngIf="videoUrl"
        [ngClass]="{ 'active': currentGalleryImageIndex === 1000,
          'shadow-none rounded-lg border-gray': environmentVariables?.NEW_PRODUCTS_DETAILS_UI
        }" 
        class="gallery-item my-2 mr-2 p-1 pointer">
        <img [src]="videoThumbUrl" alt="video Thumb" default="./assets/images/placeholder70.png"
          onError="this.src='./assets/images/placeholder70.png';" />
      </div>
      <ng-container *ngIf="images?.length">
        <div (mouseenter)="getImagePath(img.url, i, 'image', true)"
          *ngFor="let img of images; let i = index"
          [ngClass]="{ 'active': currentGalleryImageIndex === i,
            'shadow-none rounded-lg border-gray': environmentVariables?.NEW_PRODUCTS_DETAILS_UI
          }"
          class="gallery-item my-2 mr-2 p-1 pointer">
          <img [src]="img.url" [alt]="productName" default="./assets/images/placeholder70.png"
            onError="this.src='./assets/images/placeholder70.png';" />
        </div>
      </ng-container>
    </div>

    <div class="right-icon material-icons next-arrow pointer" (click)="getNextThumbnail()" *ngIf="gallaryScrollarea">
      keyboard_arrow_right
    </div>
  </div>
</div>

<div *ngIf="fullZoomPreview" class="full-zoom-preview-overlay">
  <span (click)="toggleFullZoomPreview()" class="material-icons close-modal-btn pointer">close</span>
  <div class="left-section">
    <div class="zoom-tools">
      <div (click)="zoomIn()" class="material-icons pointer my-2">zoom_in</div>
      <div (click)="zoomOut()" class="material-icons pointer my-2">
        zoom_out
      </div>
    </div>
    <div (click)="prevImage()" class="material-icons prev-arrow pointer">
      keyboard_arrow_left
    </div>
  </div>
  <div class="modal-container" [ngStyle]="{ height: images && images.length > 1 ? '100vh' : '100%' }">
    <div class="
        d-flex
        justify-center
        align-items-center
        full-zoom-container
        w-100
        h-100
      ">
      <img #fullZoomImage [src]="zoomImage" alt="Zoom Image" (load)="setFullZoomImageSize()" class="full-zoom-image"
        default="./assets/images/placeholder70.png" onError="this.src='./assets/images/placeholder70.png';" />
    </div>
  </div>
  <div class="right-section">
    <div (click)="nexImage()" class="material-icons next-arrow pointer">
      keyboard_arrow_right
    </div>
  </div>
  <div class="alternative-images" *ngIf="images && images.length > 1">
    <div class="container-images p-2">
      <div (click)="selectAlternativeImage(img, idx)" *ngFor="let img of images; let idx = index"
        [ngClass]="{ active: currentImageIndex === idx }" class="img-box mx-3">
        <img [src]="img.url" alt="alternative-images" default="./assets/images/placeholder70.png"
          onError="this.src='./assets/images/placeholder70.png';" />
      </div>
    </div>
  </div>
</div>
